import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../../core/config.service';
import {Injectable} from '@angular/core';


@Injectable()
export class GatewayReportService {
  constructor(private configService: ConfigService,
    private httpClient: HttpClient) {
  }

   getGatewayPings(body: any): any {
    const url = this.configService.getGatewayUrl() + '/ping/gateway';
    return this.httpClient.post(url, body).toPromise();
  }
  
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-status/reports/gateway-report.service.ts